import { Variants } from "../animations/variants";
import { SearchResultsSectionOrder } from "../components/results/data";

export function useResultsOrder(order: SearchResultsSectionOrder) {
  // Determine which animation to use
  const animationVariants = order === SearchResultsSectionOrder.First ? Variants.FadeInUp : Variants.FadeInUpDelayed;

  // Build the className based on order
  let className = "dewey--search--section--motion";
  if (order === SearchResultsSectionOrder.Second) {
    className += " dewey--search--order--second";
  }

  return {
    animationVariants,
    className,
  };
}
